import flatpickr from 'flatpickr';
import { applyCalendarTheme, bindCalendarOpening } from '@js/helpers/CalendarTheme';

class FloorplanDatePicker {
    constructor() {
        this.picker = null;
    }

    destroy() {
        this.picker?.destroy();
        this.picker = null;
    }

    init() {
        this.destroy();

        const input = document.getElementById('floorplan-movein-dp');
        const valueInput = document.getElementById('movein-input');
        if (!input || !valueInput) return;

        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 90);

        const filterRow = input.closest('#search-floorplan');
        const applyTheme = (dates, dateStr, instance) => {
            applyCalendarTheme(instance.calendarContainer, filterRow || input);
        };

        this.picker = flatpickr(input, {
            dateFormat: 'm/d/Y',
            defaultDate: valueInput.value ? flatpickr.parseDate(valueInput.value, 'Y-m-d') : null,
            minDate: 'today',
            maxDate,
            disableMobile: true,
            allowInput: false,
            onReady: (dates, dateStr, instance) => {
                applyTheme(dates, dateStr, instance);
                bindCalendarOpening(instance);

                const actions = document.createElement('div');
                actions.className = 'floorplan-datepicker-actions';
                for (const [label, action] of [
                    ['Today', () => instance.setDate(new Date(), true)],
                    ['Clear', () => instance.clear()],
                ]) {
                    const button = document.createElement('button');
                    button.type = 'button';
                    button.textContent = label;
                    button.addEventListener('click', () => {
                        action();
                        instance.close();
                    });
                    actions.append(button);
                }
                instance.calendarContainer.append(actions);
            },
            onOpen: applyTheme,
            onChange: (dates, dateStr, instance) => {
                valueInput.value = dates.length ? instance.formatDate(dates[0], 'Y-m-d') : '';
                valueInput.dispatchEvent(new Event('input', { bubbles: true }));

                const search = document.getElementById('floorplan-search-component');
                if (search && window.htmx) window.htmx.trigger(search, 'refresh');
                input.blur();
            },
        });
    }
}

export default new FloorplanDatePicker();
